
// components/InstructionsBox.jsx
"use client";

export default function InstructionsBox() {
  return (
    <section className="my-[40px] md:my-[60px] lg:my-[80px]">
      <div className="max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto">
        <div className="mx-auto  bg-[#e9f7ff] px-6 py-7 md:px-10 md:py-8">
          <h2 className="text-2xl md:text-3xl font-bold text-[#0072b8] mb-4">
            Instructions
          </h2>

          <ul className="list-disc list-inside space-y-3 text-[#0066a1] text-sm md:text-base">
            <li>
              The online application is for admission to programmes offered in
              Medhavi Skills University (Sikkim).
            </li>
            <li>Application Form Fee is Non-Refundable.</li>
            <li>
              We strongly recommend you use a valid Email ID to register.
              However, in case you do not have an Email ID available, please
              type <span className="font-mono">@gmail.com</span> instead,
              e.g. <span className="font-mono">your.mail@gmail.com</span>.
            </li>
            <li>
              Medhavi Skills University (Sikkim) Query Management System:
              Applicants are strongly advised to use the Medhavi Skills
              University (Sikkim) Query Management System (Medhavi Skills
              University (Sikkim)-QMS), rather than an email, to get a quick
              response.
              <ol className="list-decimal list-inside mt-2 space-y-1 pl-4">
                <li>Click on [Any Queries? Ask US] in your dashboard.</li>
                <li>Select the query category and submit your query.</li>
              </ol>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
